import { useCallback, useState } from 'react';
import { metaAgentModelChoice } from '@/utils/metaAgentModel';

/**
 * The model picker of one meta-agent conversation (see utils/metaAgentModel).
 * Only the person's own pick is state — values that arrive later are shown as
 * soon as they land. Call `clearPick` when the panel moves to another
 * conversation without remounting: a pick holds for its own conversation only.
 */
export function useMetaAgentModel(
  conversationModel: string | null | undefined,
  orgDefault: string | null | undefined,
) {
  const [picked, setPicked] = useState<string | null>(null);
  const { shown, requested } = metaAgentModelChoice(picked, conversationModel, orgDefault);
  const pick = useCallback((model: string) => setPicked(model || null), []);
  const clearPick = useCallback(() => setPicked(null), []);
  return { shownModel: shown, requestedModel: requested, pick, clearPick };
}
